import { Grid, Box, Typography, Container } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const DefaultTermOfUse = () => {
  const { t } = useTranslation();
  return <div className="footer-document-content"></div>;
};

export default DefaultTermOfUse;
